export default "__VITE_ASSET__a26HlPl9__"